import React from 'react';
import { FaPiggyBank, FaEthereum, FaExternalLinkAlt } from 'react-icons/fa';
import { useDolphin } from '../../hooks/useDolphin';
import { CONTRACTS } from '../../config';

export default function Treasury() {
  const { stats } = useDolphin();
  const contractAddress = CONTRACTS.DOLPHIN;
  return (
    <div className="featured-stat-card">
      <div className="featured-stat-header">
        <span className="featured-stat-icon">
          <FaPiggyBank />
        </span>
        <span className="featured-stat-label">Treasury</span>
      </div>
         <div className="featured-stat-value">DOLP Balance: <span className="text-gold">{stats.totalSupply ? Number(stats.totalSupply).toLocaleString(undefined, {maximumFractionDigits: 0}) : '--'}</span></div>
      <div className="price-range-bar">
           <div className="price-range-fill" style={{ width: `${stats.totalSupply ? 50 : 0}%` }}></div> {/* width is dynamic, keep inline */}
      </div>
      <div className="price-range-labels">
        <span>Contract</span>
        <span className="mono">{contractAddress}</span>
        <span>Native</span>
      </div>
         <div className="treasury-bottom-row">
           <span className="treasury-native"><FaEthereum className="icon-inline"/> Native: {stats.nativeBalance ? stats.nativeBalance : '--'}</span>
           <a href={`https://polygonscan.com/address/${contractAddress}`} className="explorer-link" target="_blank" rel="noopener noreferrer"><FaExternalLinkAlt className="icon-inline"/>View on Explorer</a>
         </div>
    </div>
  );
}
